<template>
  <div class="login-dailog dialog col-block">
    <div class="title-container col-block">
      <div class="title">{{ $t('LAYOUT.dialog.login.___title'/* 使用者登入 */) }}</div>
    </div>
    <div :style="{ height: '20px' }"></div>
    <div class="form-container input-group col-block">
      <input type="text" :placeholder="$t('LAYOUT.dialog.login.form.placeholder.___account'/* 帳號 */)" v-model="login.account" @keyup.enter.prevent.stop="e => $refs['password'].focus()">
      <div :style="{ height: '20px' }"></div>
      <input ref="password" type="password" :placeholder="$t('LAYOUT.dialog.login.form.placeholder.___password'/* 密碼 */)" v-model="login.password" @keyup.enter.prevent.stop="e => validateUserLogin()">
      <div :style="{ height: '20px' }"></div>
      <select v-model="login.role" :style="!login.role ? { color: '#aaaaaa' } : {}">
        <option disabled value="">{{ $t('LAYOUT.dialog.login.form.placeholder.___role'/* 選擇角色 */) }}</option>
        <option value="user">{{ $t('LAYOUT.dialog.login.form.option.role.___user'/* 用戶 */) }}</option>
        <option value="admin">{{ $t('LAYOUT.dialog.login.form.option.role.___admin'/* 管理員 */) }}</option>
      </select>
    </div>
    <div :style="{ height: '30px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="white-button" @click="e => $emit('changeModal')">
        <span>{{ $t('COMMON.button.___cancel'/* 取消 */) }}</span>
      </button>
      <div :style="{ width: '15px' }"></div>
      <button class="main-button" :class="{ loading: onSubmit }" @click="e => validateUserLogin()">
        <i class="fa fa-lg fa-sign-in" aria-hidden="true"></i>
        <span>{{ $t('COMMON.button.___login'/* 登入 */) }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import { postUser } from '../../api'
import loginData from '../../mixins/loginData.vue'
import toastMethods from '../../mixins/toastMethods.vue'

export default {
  mixins: [
    loginData,
    toastMethods
  ],
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      login: {
        account: '',
        password: '',
        role: ''
      },
      onSubmit: false
    }
  },
  methods: {
    async validateUserLogin () {
      this.onSubmit = true
      let result = await this.$validator.validateAll()
      if (result) {
        await this.userLogin()
      }
      this.onSubmit = false
    },
    async userLogin () {
      try {
        let data = this.login
        let response = await postUser(data)
        this.setUserData(response)
        this.addToast('success', response.data.result)
        this.$router.push({ name: 'index' })
      } catch (error) {
        this.setLoginAction(false)
        this.addToast('error', !error.response ? error.message : error.response.data.result.message)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/login.vue